var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestService } from "../RestService";
const URL = "/users";
export class UserApi extends RestService {
    getAll(params, role) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(URL, Object.assign(Object.assign({}, params), { role }));
            if (res.ok) {
                return res.data;
            }
            else {
                return null;
            }
        });
    }
    getOne(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(`${URL}/${userId}`);
            if (res.ok) {
                return res.data;
            }
            else {
                return null;
            }
        });
    }
    getMe() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(`${URL}/me`);
            if (res.ok)
                return res.data;
            return null;
        });
    }
    create(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.post(URL, user, this.headers.json);
            if (res.ok)
                return true;
            return res.data;
        });
    }
    update(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(URL, user, this.headers.json);
            return res.ok;
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${URL}/${id}`;
            const res = yield this.httpClient.delete(url);
            return res.ok;
        });
    }
    deleteMobileUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${URL}/mobile-user`;
            const res = yield this.httpClient.delete(url);
            return res.ok;
        });
    }
    updateActivity(ids, newStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/activity`, { ids, newStatus });
            return res.ok;
        });
    }
    deleteBatch(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.delete(`${URL}/batch`, { ids });
            return res.ok;
        });
    }
}
//# sourceMappingURL=UserApi.js.map